import * as React from 'react';
import { Tabs } from 'antd';
import { resolve } from 'inversify-react';

import CheckoutDataService from 'src/app/accounting/payment-gateway/checkout-service';
import GatewayComponent from 'src/app/accounting/payment-gateway/gateway-component';

interface Props {
    onAuthorizePayment: (t, serviceName: string, extra?: { [id: string]: any }) => void;
    cardHolder: string;
}

interface State {
	loading: boolean;
	services: IServiceInfo[];
}

export default class GatewayTabs extends React.Component<Props, State> {
	@resolve
	private checkoutService: CheckoutDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			loading: false,
			services: []
		}
	}

	componentDidMount(): void {
		this.load();
	}

	private async load(): Promise<void> {
		this.setState({ loading: true });
		try {
			var services = await this.checkoutService.getServiceInformation();
			this.setState({ services });
		} catch (e) {
			console.log(e);
		} finally {
			this.setState({ loading: false });
		}
	}

	render(): React.ReactNode {
		if (this.state.loading) {
			return null;
		}

		if (this.state.services.length == 0) {
			return (
				<h2>There is no credit card payment gateway enabled</h2>
			);
		}

		return (
			<Tabs>
				{
					this.state.services.map((item, index) => (
						<Tabs.TabPane key={item.paymentGatewayName + index} tab={item.paymentGatewayName}>
							<GatewayComponent
								service={item}
                                onAuthorizePayment={this.props.onAuthorizePayment}
                                cardHolder={this.props.cardHolder}
							/>
						</Tabs.TabPane>
					))
				}
			</Tabs>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/payment-gateway/gateway-tabs.tsx